import React, { useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useDispatch, useSelector } from "react-redux";
import { GetTc } from "../redux/actions/teams/members/GetTcAction";
import { UpdateTc } from "../redux/actions/teams/members/UpdateTcAction";
import { PulseLoader } from "react-spinners";

const TermsConditions = () => {
  const dispatch = useDispatch();
  const [content, setContent] = useState("");
  const [editing, setEditing] = useState(false);

  const { response, loading, error } = useSelector((state) => state.getTc);
  const { loading: updateLoading, error: updateError } = useSelector((state) => state.updateTc);

  useEffect(() => {
    dispatch(GetTc());
  }, [dispatch]);

  useEffect(() => {
    if (response?.data) {
      setContent(response.data);
    }
  }, [response]);

  const handleSave = () => {
    dispatch(UpdateTc({ content }))
      .then(() => setEditing(false))
      .catch((err) => console.error("Failed to update TC:", err));
  };

  if (loading) return <div className="text-center p-5">Loading...</div>;
  if (error) return <div className="text-center text-danger p-5">{error.data}</div>;

  return (
    <div className="content-wrapper" style={{ backgroundColor: "#f5f5f5" }}>
      <section className="main-section">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-8">
              <div className="p-4 shadow rounded bg-white">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5>Terms and Conditions</h5>
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => setEditing(!editing)}
                  >
                    {editing ? "Cancel" : "Edit"}
                  </button>
                </div>

                {!editing ? (
                  <div
                    className="p-2"
                    style={{ minHeight: "150px" }}
                    dangerouslySetInnerHTML={{ __html: content }}
                  />
                ) : (
                  <div>
                    <CKEditor
                      editor={ClassicEditor}
                      data={content}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setContent(data);
                      }}
                    />
                    <div className="text-center mt-3">
                      <button
                        className="btn btn-success px-4"
                        onClick={handleSave}
                        disabled={updateLoading}
                      >
                        {updateLoading ? <PulseLoader size={8} /> : "Save"}
                      </button>
                      {updateError && (
                        <div className="text-danger mt-2">
                          {updateError.data || "Update failed"}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
